export default __webpack_public_path__ + "static/media/0000000Led-0003973197Mundo.3d66376f.jpg";